export default __webpack_public_path__ + "static/media/game-end.c022999b.mp3";